import React from 'react';
import { RichText } from '../richTextOptions';

const ContentfulBlockCustomerReviewCard = (props) => {
    const { reviewIntro, reviewInformation, review } = props;
    
    return (
        <div className="customer-review-card">
            {
                reviewIntro && (
                    <div className="review-intro">
                        <RichText data={reviewIntro} />
                    </div>
                )
            }
            {
                reviewInformation && (
                    <div className="review-info">
                        <RichText data={reviewInformation} />
                    </div>
                )
            }
            {
                review && (
                    <div className="review">
                        <RichText data={review} />
                    </div>
                )
            }
        </div>
    )
}

export { ContentfulBlockCustomerReviewCard };
